import * as React from "react"
import { create } from "zustand"

import {
  examRoleFromLoginSession,
  type ExamAppRole,
} from "@/lib/exam-blueprint-access"

export type UserRole = ExamAppRole

interface ExamRoleState {
  role: UserRole
  setRole: (role: UserRole) => void
}

const getInitialRole = (): UserRole => {
  if (typeof window !== "undefined") {
    return examRoleFromLoginSession()
  }
  return "Admin"
}

const useExamRoleStore = create<ExamRoleState>((set) => ({
  role: getInitialRole(),
  setRole: (newRole) => {
    if (typeof window !== "undefined") {
      localStorage.setItem("exam-user-role", newRole)
    }
    set({ role: newRole })
  },
}))

/** Align exam role with the active sign-in session (Super Admin → Admin, Faculty → Faculty). */
export function syncExamRoleFromLoginSession(): UserRole {
  const next = examRoleFromLoginSession()
  useExamRoleStore.getState().setRole(next)
  return next
}

export function ExamRoleProvider({ children }: { children: React.ReactNode }) {
  React.useEffect(() => {
    syncExamRoleFromLoginSession()
  }, [])
  return <>{children}</>
}

export function useExamRole() {
  const role = useExamRoleStore((state) => state.role)
  const setRole = useExamRoleStore((state) => state.setRole)
  return { role, setRole }
}

export function useCanManageAssessmentBlueprint(): boolean {
  const role = useExamRoleStore((state) => state.role)
  return role === "Admin"
}
